export class Accountsgroup {
    Id:Number ;
    AccountId :Number ;
    ParentAccountId:Number;
    AccountGroupName: string;
    DispalyOrder:Number;
    DisplayIn: string;
    GroupCode: string;
    Predefined: boolean;
    IsActive: boolean;
    Flag : Number;
}

